module.exports = __webpack_public_path__ + "img/1523613569.0b999a26.jpg";